import dayjs from "dayjs";

export const parsePurchaseSupplierSkusResume = (data: any[]): any[] => {
  const res = [];

  for (const item of data) {
    res.push({
      "pedido-id": item.productCode,
      "pedido-centro": item.storeId + " - " + item.storeDescription,
      "pedido-numero": item.documentId,
      "pedido-sku": item.productId,
      "pedido-descricao": item.productDescription,

      "quantidade-total": item.orderedQuantity,
      "quantidade-entregue": item.receivedQuantity,
      "quantidade-pendente": item.quantityToSupply,
      "quantidade-agendada": item.quantityScheduled,
      "quantidade-pedente-agendada": item.quantityPendingScheduling,
      "quantidade-agendar": item.quantitySchedule,
      "data-prevista": dayjs(item.expectedDeliveryDate).format("DD/MM/YYYY "),
    });
  }

  return res;
};
